import { ScriptDef, ScriptTheme } from '../../types';

export const MOVIE_AIQING_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_086',
        name: '喜帖',
        genre: 'movie',
        synopsis: '婚庆策划师池娜有个怪癖：喜宴砍价，散伙宴加钱，专替人把退婚宴改成生日宴、把离婚宴办成同学会，毒舌司仪穆子期是她唯一的搭档。女企业家黎晚亭重金请她办一场离婚暨退休宴，条件是把三任前夫全请到主桌。三份回执陆续寄到，第三份的署名出人意料。',
        roles: [
            {
                name: '池娜',
                roleType: '女主角',
                billing: 1,
                intro: '婚庆策划，喜宴方案四平八稳，散伙宴办得热气腾腾。她自己那场没办成的婚宴，圈里没人当面提。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, temperament: 3, talent: 2, wisdom: 2 },
            },
            {
                name: '穆子期',
                roleType: '男配角',
                billing: 2,
                intro: '司仪，主持词从不重样，毒舌是暖场方式。给散伙宴定的规矩：只许敬杯，不许敬往事。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'charm', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, charm: 2, talent: 2 },
            },
            {
                name: '小林',
                roleType: '女配角',
                billing: 4,
                intro: '婚庆公司实习策划，池娜的助手，搬桌子、扎花门、对接酒店全归她。散伙宴那天她哭得比谁都凶，说下辈子也要找个人办这么好的离婚宴。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { charm: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Romance, ScriptTheme.Comedy, ScriptTheme.Urban],
        heat: 50,
        baseScore: 7.3,
    },
    {
        id: 'SCRIPT_087',
        name: '晚点落地',
        genre: 'movie',
        synopsis: '行业骤停，出境领队宋扬滞留南半球小城，签证只剩十九天。她借住一对老夫妇的民宿，先照旧把作息表改成发团时刻表，后来索性用领队本事把民宿做成滞留者互助站：富余房间、中文课堂、机场拼车，名单钉在门口。签证到期那天，老太太在名单末尾替她添了一行：房间常留。',
        roles: [
            {
                name: '宋扬',
                roleType: '女主角',
                billing: 1,
                intro: '金牌领队，能同时处理丢护照、丢行李和丢队的大妈。滞留后头一回过没有行程表的日子。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, temperament: 3, talent: 2, wisdom: 2 },
            },
            {
                name: '米塔',
                roleType: '女配角',
                billing: 3,
                intro: '民宿长住客，数字游民，毒舌是社交货币。给互助站拉群，群规第一条：先吃饭，再谈乡愁。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, charm: 2 },
            },
            {
                name: '陆延',
                roleType: '男配角',
                billing: 4,
                intro: '民宿夜班店员，见过太多赶不上飞机的人，总结出三十七种失眠的睡姿。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.Comedy, ScriptTheme.LifeStyle],
        heat: 45,
        baseScore: 7.0,
    },
    {
        id: 'SCRIPT_088',
        name: '高定女孩',
        genre: 'movie',
        synopsis: '时尚杂志小助理乔安琪的一条丝巾设计被主编看中，破格调进核心组负责年度大秀。对手编辑柳岸处处使绊，反被董事会当场揭穿出局。大秀当晚她的压轴款引爆全场，她升任创意总监。',
        roles: [
            {
                name: '乔安琪',
                roleType: '女主角',
                billing: 1,
                intro: '杂志小助理，有设计天赋，随手画的图案总能打动人，靠着一条丝巾设计从后勤组被破格调进核心组。',
                // 2026-09-30 一二番同级修：与二番柳岸同为 Lv.5（片酬同为 15 万）→ 一番升一级；
                // 门槛/成长按台账 §3~§4 Lv6 档重推（50/45/40、Σ8 = 3/3/2），属性顺序不动
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, talent: 3, temperament: 2 },
            },
            {
                name: '柳岸',
                roleType: '女二号',
                billing: 2,
                intro: '资深编辑，海归背景，在杂志社扎根多年，人脉广、出手快。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '曾格格',
                roleType: '女配角',
                billing: 3,
                intro: '乔安琪的闺蜜兼同事，嗓门大、心眼少，每当乔安琪熬不下去的时候，她比谁都着急。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Romance, ScriptTheme.Urban, ScriptTheme.Occupation],
        heat: 36,
        baseScore: 5.4,
    },
    {
        id: 'SCRIPT_100',
        name: '散伙饭',
        genre: 'movie',
        synopsis: '毕业散伙饭上，唐既明与简一诺被起哄定了情，此后一年两人隔着高铁和时差轮班视频，恋爱谈得像打卡。第三百天，简一诺拿到出国的offer，两人在视频里都没提分手。一场被现实拉长的感情，散在两个各自要去的方向上。',
        roles: [
            {
                name: '唐既明',
                roleType: '男主角',
                billing: 1,
                intro: '应届毕业生，进大厂做程序员，工位在负一层。给简一诺的备注改了又改，最后一次删成了空白。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, talent: 3, temperament: 2 },
            },
            {
                name: '简一诺',
                roleType: '女主角',
                billing: 1,
                intro: '保研直博，导师的课题和她想要的隔着两个实验室。日记写在小票背面，头一张是散伙饭的结账单。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, talent: 3, temperament: 2 },
            },
            {
                name: '佟大乐',
                roleType: '男二号',
                billing: 2,
                intro: '唐既明室友，散伙饭组织者，毕业后回老家考编。班级群里的最后一条消息，是他结婚的请柬。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '江篱',
                roleType: '女二号',
                billing: 2,
                intro: '简一诺室友，毕业后进了家乡电视台。被问到"该不该去"时，只回了一句"我妈喊我吃饭"。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '许南嘉',
                roleType: '女配角',
                billing: 4,
                intro: '班里的活账本，四年里谁跟谁好过、谁欠谁一句没说的话，她全记着。散伙饭上没喝一滴酒，把整桌人的醉话听了个遍。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
            {
                name: '周远',
                roleType: '男配角',
                billing: 5,
                intro: '唐既明组里的实习生，替他代抢过回家的票。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Romance, ScriptTheme.Urban],
        heat: 43,
        baseScore: 6.3,
    },
    {
        id: 'SCRIPT_101',
        name: '托举',
        genre: 'movie',
        synopsis: '双人滑搭档褚一苇与桑榆配滑九年，褚一苇膝伤退役后转做教练，桑榆换了新搭档拿下全国冠军，退役后嫁给经纪人。两年后她的婚礼请柬寄到褚一苇手上，附言一句：入场音乐你定。婚礼当天他去了，坐在最后一排，替她挑完了全场音乐。',
        roles: [
            {
                name: '褚一苇',
                roleType: '男主角',
                billing: 1,
                intro: '前双人滑男伴，膝伤退役转做教练，带单滑学员。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, stamina: 3, charm: 2 },
            },
            {
                name: '桑榆',
                roleType: '女主角',
                billing: 1,
                intro: '全国冠军，退役后嫁给经纪人。夺冠采访只提过一回旧搭档，说完"他教我的"就换了话题。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, stamina: 3, talent: 2 },
            },
            {
                name: '边锐',
                roleType: '男二号',
                billing: 2,
                intro: '桑榆的丈夫兼经纪人，经济适用型好人。婚礼座位表排了三版，把褚一苇安排在最后一排靠门。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '陶可',
                roleType: '女配角',
                billing: 4,
                intro: '褚一苇退役后带的单滑学员，天赋平平，练得最狠。婚礼那天她坐在教练旁边，替他递了整场纸巾。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'stamina', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { stamina: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Romance, ScriptTheme.LifeStyle],
        heat: 34,
        baseScore: 5.2,
    },
    {
        id: 'SCRIPT_102',
        name: '雾岛来信',
        genre: 'movie',
        synopsis: '畅销小说改编：少女白初雪为完成外婆遗愿登上雾岛，与失忆三年的画家慕夜辰相恋。画家恢复记忆后得知她正是当年事故遇难者的妹妹，不告而别；她追到疗养院，他得了绝症，绝症痊愈，她又遭遇车祸。此后两年，失忆、绝症与车祸接连落在两人身上，每一次转机，都由外婆留下的信推动。',
        roles: [
            {
                name: '白初雪',
                roleType: '女主角',
                billing: 1,
                intro: '治愈系少女，出场始终带着浅笑，即便在外婆的葬礼上也不例外。她的每一次命运转机，都由外婆留下的一封信推动。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '慕夜辰',
                roleType: '男主角',
                billing: 1,
                intro: '失忆画家，三年只穿白衬衫，画来画去都是同一片海。恢复记忆那天，他冒雨离开了雾岛。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '温念白',
                roleType: '女二号',
                billing: 2,
                intro: '白初雪的闺蜜，旅游节目编导。她每次上岛都替两人梳理前情，理得头头是道，唯独没发现外婆的信里日期对不上。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Romance, ScriptTheme.Mystery],
        heat: 23,
        baseScore: 3.2,
    },
    {
        id: 'SCRIPT_119',
        name: '琴房',
        genre: 'movie',
        synopsis: '上海的译制厂里，配音演员温从容与钢琴调律师关雪松共用一间旧琴房，错峰使用，从没打过照面，只在琴凳抽屉里传纸条。梅雨季琴房漏水停修，纸条断了三周。恢复使用的第一个周六，温从容提前到了，琴还是温的。',
        roles: [
            {
                name: '温从容',
                roleType: '女主角',
                billing: 1,
                intro: '配音演员，配过译制片里所有的痴情女配，离异独居，每周去译制厂的旧琴房练声。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, charm: 3 },
            },
            {
                name: '关雪松',
                roleType: '男主角',
                billing: 1,
                intro: '钢琴调律师，手稳话少，规矩是调过的琴几天不碰。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'artistry', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, artistry: 3 },
            },
            {
                name: '雷行舟',
                roleType: '男配角',
                billing: 3,
                intro: '译制厂导演，温从容的同事，有事没事来串门。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '卫青梧',
                roleType: '女配角',
                billing: 3,
                intro: '译制厂的字幕翻译，琴房隔壁的常客。梅雨季那三周，纸条是她一张张收进抽屉的。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.Romance, ScriptTheme.LifeStyle],
        heat: 59,
        baseScore: 9.0,
    },
    {
        id: 'SCRIPT_120',
        name: '不打烊',
        genre: 'movie',
        synopsis: '火车站后街的通宵理发店由文秀真接手经营，凌晨只做三种生意：赶头班车的、下夜班的、睡不着的。出租车司机解千山每周三凌晨来刮脸，几年只刮脸，不动头发。入冬他一连数周没来，开春再来，坐上椅子只说了一句：全剪。剪完付清了这些年的账。',
        roles: [
            {
                name: '文秀真',
                roleType: '女主角',
                billing: 1,
                intro: '通宵理发店老板，手艺是父亲压着教的，常陪客人聊天，客人说什么她接什么。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '解千山',
                roleType: '男配角',
                billing: 2,
                intro: '夜班出租车司机，专跑火车站到城郊的线，刮脸从不闲聊，小费给得比谁都齐。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '林朝',
                roleType: '女配角',
                billing: 3,
                intro: '理发店隔壁早餐铺的姑娘，凌晨给夜班客人留一盏灯。解千山数周没来的那阵，是她先问起的。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, temperament: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 54,
        baseScore: 8.6,
    },
    {
        id: 'SCRIPT_121',
        name: '焚稿',
        genre: 'movie',
        synopsis: '朝廷削藩，女刺客燕拂奉命取辞官老史官的性命，他手里的起居注记着三代藩镇的实情。她扮作抄经人进府跟了三日：老人晒书、烧信，最后开始一页页烧自己的书稿。第三日夜里，老人回头对她说：姑娘，你的墨该干了。刀出鞘与否，那一夜谁也没有看见。',
        roles: [
            {
                name: '燕拂',
                roleType: '女主角',
                billing: 1,
                intro: '刺客，剑不出鞘就能取人性命，师门规矩是杀有罪之人，无声无息。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2, wisdom: 2 },
            },
            {
                name: '宣礼',
                roleType: '男配角',
                billing: 3,
                intro: '府中侍童，负责添茶换水，水添了几回都拿炭条记在灶膛边的砖上。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, charm: 2 },
            },
            {
                name: '温苒',
                roleType: '女配角',
                billing: 3,
                intro: '褚怀瑾的女儿，远嫁而来，劝父南下。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Action],
        heat: 48,
        baseScore: 7.2,
    },
    {
        id: 'SCRIPT_122',
        name: '长梦',
        genre: 'movie',
        synopsis: '南方山城的老收费站撤站前夜，收费员罗浮生值守最后一个夜班。隧道检修封路，他提灯巡检，从迈过检修口起是六十分钟的一镜到底：应急灯次第亮起，他在梦境般的隧道里追上了十年前违规放行的那辆车，也放过了当年的自己。天亮时，他还站在岗亭里。',
        roles: [
            {
                name: '汤笙',
                roleType: '女主角',
                billing: 1,
                intro: '监控调度中心值班员，十一年每夜通过对讲机报路况，常跑夜线的人她听声音就认得出。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '雷大鱼',
                roleType: '男配角',
                billing: 3,
                intro: '隧道检修工，封路的围挡归他摆。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '苏桐',
                roleType: '女配角',
                billing: 3,
                intro: '隧道管理所的调度员，汤笙的对班。罗浮生最后一夜的对讲机里，每隔十分钟报一次路况的是她。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 43,
        baseScore: 6.9,
    },
];
